import { isValid } from 'cc-validate'

export default class CreditCard
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...CreditCard.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$input = this.DOM.$el.querySelector(this.options.selectorInput)

        if (this.DOM.$input) {
            this.DOM.$input.addEventListener('keyup', this.onInputKeyUp.bind(this), { passive: true })
        }
    }

    onInputKeyUp(e) {
        const number = e.target.value.replace(/\s/g, '')
        const result = isValid(number)

        if (result.isValid) {
            this.DOM.$el.dataset[this.options.attrType] = result.cardType
        } else {
            this.DOM.$el.dataset[this.options.attrType] = ''
        }

        this.DOM.$el.classList.toggle(this.options.classNameIsValid, result.isValid)
        this.DOM.$input.value = result.cardNumber.trim()
        this.DOM.$input.focus()
    }
}

CreditCard.prototype.defaults = {
    attrType: 'creditCardType',
    classNameIsValid: 'is-valid',
    selectorIcon: '.js-creditCardIcon',
    selectorInput: '.js-creditCardInput',
}